import { InputWithSign } from '@/modules/common/components/input-with-sign';
import styles from './index.module.sass';
import { InputSignWrap } from '@/modules/common/components/input-sign-wrap';
import {
  $logisticRanges,
  editLogisticRange,
  removeLogisticRange,
} from '@/modules/mixing/store/logistics.store';
import { Modal, notification } from 'antd';
import { useStore } from 'effector-react';
import { handleClick } from '@/modules/helpers/handler-click/index.helper';

export const RangeItem = ({
  i,
  last = false,
  begin,
  border,
  pricePart,
  id,
  recalculateBorders,
}: {
  i: number;
  last?: boolean;
  begin: number;
  border: number;
  pricePart: number;
  id?: number | null;
  recalculateBorders: () => void;
}) => {
  const data = useStore($logisticRanges);

  return (
    <div
      className={styles.root}
      style={{ borderBottom: last ? 'none' : '2px solid #EEF2FD' }}
    >
      <span>Диапазон {i + 1}</span>
      <InputSignWrap className={styles.inpItem} label="начало диапазона">
        <div className={styles.wrapInner}>
          {begin} <span>км</span>
        </div>
      </InputSignWrap>
      <InputWithSign
        className={styles.inpItem}
        value={border}
        label="граница диапазона"
        postfix="км"
        onClick={handleClick}
        onChange={(e) => {
          editLogisticRange({
            idx: i,
            data: {
              id: id,
              start: begin,
              priceForPart: pricePart,
              border: +e.target.value.replace(/[^\d]/g, ''),
            },
          });
          recalculateBorders();
        }}
        onWheel={(e: any) => {
          e.preventDefault();
          const input = String(border);
          const currentValue = parseFloat(input) || 0;
          const delta = e.deltaY > 0 ? -1 : 1;

          // Проверяем новое значение до его установки
          const newValue = currentValue + delta;
          if (newValue < 0) {
            return; // Прерываем выполнение если новое значение меньше нуля
          }

          editLogisticRange({
            idx: i,
            data: {
              id: id,
              start: begin,
              priceForPart: pricePart,
              border: +newValue,
            },
          });
          recalculateBorders();
        }}
      />
      <InputWithSign
        className={styles.inpItem}
        value={pricePart}
        label="стоимость за т/км"
        postfix="₽ т/км"
        onClick={handleClick}
        onChange={(e) =>
          editLogisticRange({
            idx: i,
            data: id
              ? {
                  id: id,
                  start: begin,
                  priceForPart: +e.target.value.replace(/[^\d]/g, ''),
                  border,
                }
              : {
                  start: begin,
                  priceForPart: +e.target.value.replace(/[^\d]/g, ''),
                  border,
                },
          })
        }
        onWheel={(e: any) => {
          e.preventDefault();
          const input = String(pricePart);
          const currentValue = parseFloat(input) || 0;
          const delta = e.deltaY > 0 ? -1 : 1;

          // Проверяем новое значение до его установки
          const newValue = currentValue + delta;
          if (newValue < 0) {
            return; // Прерываем выполнение если новое значение меньше нуля
          }
          editLogisticRange({
            idx: i,
            data: id
              ? {
                  id: id,
                  start: begin,
                  priceForPart: +newValue,
                  border,
                }
              : {
                  start: begin,
                  priceForPart: +newValue,
                  border,
                },
          });
        }}
      />
      <div
        className={styles.delButton}
        onClick={() => {
          if (data.length <= 1)
            return notification.warning({
              message: 'Вы не можете удалить все диапазоны',
            });
          Modal.confirm({
            title: 'Подтвердите действие',
            content: 'Вы действительно хотите удалить данный диапазон?',
            okText: 'да',
            cancelText: 'нет',
            onOk: () => {
              removeLogisticRange({ idx: i });
              Modal.destroyAll();
            },
          });
        }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.75 7.75L12.25 12.25M12.25 7.75L7.75 12.25M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
            stroke="#E73A42"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  );
};
